import { Vue, Component, Inject } from "vue-property-decorator";

// Types
import {
  IProvisionRequestsProvider,
  IProvisionRequestsProviderMethods
} from "@/models/providers/provisionRequests";

@Component
export default class ProvisionRequestsInjectorMixin extends Vue {
  // Inject - Provision requests provider data

  @Inject({ from: "provisionRequestsProvider" })
  public readonly $requestsProviderData!: () => IProvisionRequestsProvider;

  public get $requestsData() {
    return this.$requestsProviderData();
  }

  // Inject - Provision requests provider methods

  @Inject({ from: "provisionRequestsProviderMethods" })
  public readonly $requestsMethods!: IProvisionRequestsProviderMethods;
}
